<template>
  <div class="page-preview">
    <page-preview-panel v-if="!fullscreen" :mode="mode" @switch-mode="mode = $event"></page-preview-panel>
    <page-preview-frame :loading="loading" :mode="mode">
      <iframe
        :id="iframeId"
        :src="url"
        frameborder="0"
        :style="mode === 'mobile' ? {width: '320px', height: '568px'} : {width: '100%', height: '100%'}"
        @load="onIframeLoad"
      ></iframe>
    </page-preview-frame>
  </div>
</template>

<script>
import PagePreviewFrame from './PagePreviewFrame';
import PagePreviewPanel from './PagePreviewPanel';

export default {
  name: 'page-preview',
  components: {
    PagePreviewFrame,
    PagePreviewPanel,
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
    reloadTimestamp: {
      type: Number,
    },
    url: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      fullscreen: window.innerWidth < 576,
      loading: true,
      mode: 'desktop',
    };
  },
  computed: {
    iframeElement() {
      return document.getElementById(this.iframeId);
    },
    iframeId() {
      return `page-preview-iframe-${this.id}`;
    },
  },
  watch: {
    mode(mode, previousMode) {
      const message = {type: 'switchMode', mode};
      this.iframeElement.contentWindow.postMessage(message, '*');
    },
    reloadTimestamp(timestamp, previousTimestamp) {
      if (timestamp !== previousTimestamp) {
        this.loading = true;
        this.iframeElement.contentWindow.location.reload();
      }
    },
  },
  methods: {
    onResize(event) {
      if (event.target.innerWidth < 576) {
        this.fullscreen = true;
        this.mode = 'desktop';
      } else {
        this.fullscreen = false;
      }
    },
    onIframeLoad() {
      this.loading = false;
    },
  },
  mounted() {
    window.addEventListener('resize', event => this.onResize(event));
  },
};
</script>

<style lang="scss" scoped>
.page-preview {
  background-color: #efefef;
  position: absolute;
  top: 0;
  left: 0;
  min-height: calc(100vh - var(--admin-bar-height, 0px));
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
